import { createFileRoute } from "@tanstack/react-router";
import { PortalDashboardV2Page } from "@/components/v2/pages/portal-dashboard-v2-page";

export const Route = createFileRoute("/portal/")({
  component: PortalDashboardV2Page,
});
